// Visita da página (relatório de tráfego da TIM). Sai também com a venda suspensa: sem isto a página
// não gravava nenhuma visita desde a suspensão de 30/09/2026 (medido no banco em 26/10/2026).
export function montarTrafego(search, sessionId, dev, href) {
    const q = new URLSearchParams(search)
    const trafego = {
        clienteId: null,
        sessionId,
        telefone: '',
        dataVisualizacao: new Date().toISOString(),
        url: href,
        nomeCampanha: q.get('nome_campanha'),
        tituloHtml: q.get('nome_html'),
        dataInicioCampanha: q.get('data_inicio_campanha'),
        tituloLandingPage: q.get('data_landing_page'),
        fonteUtm: q.get('fonte_utm'),
        midiaUtm: q.get('midia_utm'),
        termoUtm: q.get('termo_utm'),
        conteudoUtm: q.get('conteudo_utm'),
        nomeDispositivo: dev.nomeDispositivo,
        tipoDispositivo: dev.tipoDispositivo,
        navegador: dev.navegador,
    }
    for (const [key, value] of q.entries()) {
        trafego[key] = value
    }
    return trafego
}

// Best effort: falha de rede nunca atrapalha a página.
export async function registrarTrafego(fetcher, trafego) {
    try {
        await fetcher('/sessoes/trafego', {
            method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(trafego),
        }, {retryOn403: true})
    } catch {
        // silencioso
    }
}
